const getLocalStorageKey = (payload) => {
  return `survey-${payload}`;
};

export const setSurveyResult = (payload, hash, isFinished = false) => {
  const key = getLocalStorageKey(payload);

  localStorage.setItem(key, JSON.stringify({
    hash,
    isFinished,
  }));
};

export const getSurveyResult = (payload) => {
  const key = getLocalStorageKey(payload);

  const result = localStorage.getItem(key);

  return result ? JSON.parse(result) : null;
};
